import * as ActionTypes from '../../actions/ActionTypes';
import ImportedArticleNeedsReviewRecord from '../../records/import/ImportedArticleNeedsReviewRecord';
const INITIAL_STATE = new ImportedArticleNeedsReviewRecord();
export default function ImportedArticleNeedsReview(state = INITIAL_STATE, {
  error,
  payload,
  type
}) {
  switch (type) {
    case ActionTypes.FETCH_IMPORTED_ARTICLE_NEEDS_REVIEW_PENDING:
    case ActionTypes.UPDATE_IMPORTED_ARTICLE_NEEDS_REVIEW_PENDING:
      return INITIAL_STATE;
    case ActionTypes.FETCH_IMPORTED_ARTICLE_NEEDS_REVIEW_SUCCESS:
      return state.merge({
        error: undefined,
        isRequesting: false,
        needsReview: payload,
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'number' is not assignable to type 'null | un... Remove this comment to see the full error message
        lastLoaded: new Date().valueOf()
      });
    case ActionTypes.UPDATE_IMPORTED_ARTICLE_NEEDS_REVIEW_SUCCESS:
      return state.merge({
        error: undefined,
        isRequesting: false,
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'false' is not assignable to type 'undefined'... Remove this comment to see the full error message
        needsReview: false,
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'number' is not assignable to type 'null | un... Remove this comment to see the full error message
        lastLoaded: new Date().valueOf()
      });
    case ActionTypes.FETCH_IMPORTED_ARTICLE_NEEDS_REVIEW_ERROR:
    case ActionTypes.UPDATE_IMPORTED_ARTICLE_NEEDS_REVIEW_ERROR:
      return state.merge({
        isRequesting: false,
        error
      });
    default:
      return state;
  }
}